export default "__VITE_ASSET__78fb07c1__"